function addPropertyToAllItems() {
  fetch("/cart.js", {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  })
    .then((response) => response.json())
    .then((cart) => {
      prepareRequestBody(cart.items, cart.total_price);
    })
    .catch((error) => console.error("Error retrieving cart:", error));
}

function prepareRequestBody(cartItems, cartTotal) {
  const updates = cartItems.map((item, index) => ({
    id: item.variant_id,
    quantity: item.quantity,
    properties: {
      ...item.properties,
      _cart_total_amount: cartTotal, // Add the new property
    },
  }));
  renewCart(updates);
}

async function renewCart(updates) {
  const clearResponse = await fetch("/cart/clear.js", {
    method: "POST",
  });
  const cartCleared = await clearResponse.json();
  if (cartCleared) {
    const response = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        items: updates,
      }),
    });
    const cartCreated = await response.json();
    // Optionally check if the response is as expected and proceed accordingly
    if (cartCreated.items) {        
        window.location.href = "/checkout";
    } else {
      console.error("Failed to renew cart");
    }
  }
}
